import React, {Component} from 'react'

class FunctionsPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            action:null,
            object:null,
        };

        this.keywords = require('../data/keyword');

    }  

    handleActionChange(e,type) {
        this.setState({[type]:e.target.value});
        
    }

    addFunctions() {

        let data = {
            name : this.state.action + " " + this.state.object,
            id : "functions" + new Date().getTime(),
            type:"functions"
        }

        this.props.addFunctions(data); 
    }

    render() {

        let action = this.keywords && this.keywords.action;
        let object = this.keywords && this.keywords.object;
        
        return (
            <div className="functions-popup">
                <div className="functions-box">
                    <h3>Function</h3> 
                    <div className="wrap">
                        <div className="left">
                            <h4>1. Choose an Action</h4>
                            <ul className="radioList">
                                {action && action.map((v, k)=>{
                                    return (
                                        <li key={k}>
                                            <input id={v} name="action" type="radio" 
                                            value={v} checked={this.state.action === v}
                                            onChange={e => this.handleActionChange(e,'action')}/>
                                            <label htmlFor={v}>{v}</label> 
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        <div className="right">
                            <h4>2. And an Object</h4>
                            <ul className="radioList">
                                {object && object.map((v, k)=>{
                                    return (
                                        <li key={k}>
                                            <input id={v} name="object" type="radio" 
                                            value={v} checked={this.state.object === v}
                                            onChange={e => this.handleActionChange(e,'object')}/>
                                            <label htmlFor={v}>{v}</label> 
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="btn-wrap">
                        <button onClick={()=>this.props.onClose()} className="cancel-btn">Cancel</button>
                        <button disabled={!this.state.action || !this.state.object} 
                                onClick={()=>this.addFunctions()} 
                                className={!this.state.action || !this.state.object ? "add-btn" : "add-btn active"}>Add</button>
                    </div>
                </div>
            </div>
        )
    }
}


export default FunctionsPopup; 

